export default "__VITE_ASSET__ByZM6lzG__"